import { callBiscExtensions } from "./meta";
import { returnCodes } from "../return-codes";
import { log, logLevel } from "../logging";

var postBeidCardOwnerInfosUrl = 'bhandleid';
var postBeidCardCertificatesUrl = 'bhandleid';
var postEidPinSignedChallengeUrl = 'bhandlesignature';

export var configuration = {
    setPostBeidCardOwnerInfosUrl: url => {
        configuration.postBeidCardOwnerInfosUrl = url;
    },
    setPostBeidCardCertificatesUrl: url =>{
        configuration.postBeidCardCertificatesUrl = url;
    },
    setEidPinSignedChallengeUrl: url => {
        configuration.postEidPinSignedChallengeUrl = url;
    }
}


// The call to bisc returns both the file_version and the product_version of the BEID DLL as well as the DisPlayName and DisplayVersion of the BEID Middleware
//  For now, we have been asked to return only the DisplayVersion of the BEID Middleware only. So, the function filters on middleware_display_version.
export function getBeidVersion() {
    return callBiscExtensions("getBeidVersion");
}

// Filtering for the webextension calls is not needed 
// since BISC webextensions doesn't unnecessarily wrap the response anymore.
// Trust the unit tests ;)

export function isBeidCardAvailable() {
    return callBiscExtensions("isBeidCardAvailable");
}

export function getBeidCardFiles() {
    return callBiscExtensions("getBeidCardFiles");
}

export function getBeidCardOwnerId() {
    return callBiscExtensions("getBeidCardOwnerId");
}

export function getBeidCardOwnerAddress() {
    return callBiscExtensions("getBeidCardOwnerAddress");
}

export function getBeidCardCertificates() {
    return callBiscExtensions("getBeidCardCertificates");
}

export function getBeidCardRootCACertificate() {
    return callBiscExtensions("getBeidCardRootCACertificate");
}

export function getBeidCardCitizenCACertificate() {
    return callBiscExtensions("getBeidCardCitizenCACertificate");
}

export function getBeidCardAuthenticationCertificate() {
    return callBiscExtensions("getBeidCardAuthenticationCertificate");
}

export function getBeidCardAuthenticationCertificateChain() {
    return callBiscExtensions("getBeidCardAuthenticationCertificateChain");
}

export function getBeidCardSignatureCertificate() {
    return callBiscExtensions("getBeidCardSignatureCertificate");
}

export function getBeidCardSignatureCertificateChain() {
    return callBiscExtensions("getBeidCardSignatureCertificateChain");
}

export function signChallengeWithBeidCard(challenge) {
    return callBiscExtensions("signChallengeWithBeidCard", undefined, {challenge:challenge});
}

export function signAuthenticationChallengeWithBeidCard(challenge) {
    return signChallengeWithBeidCard(challenge);
}

export async function signAndPostEidPinChallengeWithBeidCard(challenge) {
    let signature = await signChallengeWithBeidCard(challenge);
    return  fetch(postEidPinSignedChallengeUrl, {
                method: 'POST',
                body: signature,
                headers: new Headers({'Content-Type': 'application/json'}),
                credentials: 'same-origin'
            })
            .then(resp => resp.ok ? returnCodes.Success : returnCodes.Failure);
}

export async function postBeidCardOwnerIdentity() {
    let ownerId = await getBeidCardOwnerId();
    let ownerInfosResponse = await fetch(postBeidCardOwnerInfosUrl, {
            method: 'POST',
            body: JSON.stringify(ownerId),
            headers: new Headers({'Content-Type': 'application/json'}),
            credentials: 'same-origin'
        });
    if(!ownerInfosResponse.ok) {
        log("Error trying to post beid card owner info", logLevel.Error);
        throw new Error(returnCodes.Failure);
    }
    let certs = await getBeidCardCertificates();
    let certsResponse = await fetch(postBeidCardCertificatesUrl, {
        method: 'POST',
        body: JSON.stringify(certs),
        headers: new Headers({'Content-Type': 'application/json'}),
        credentials: 'same-origin'
    });
    if(!certsResponse.ok) {
        log("Error trying to post beid card certificates", logLevel.Error);
        throw new Error(returnCodes.Failure);
    }
    return returnCodes.Success;
}